import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['expancedList', 'expanceButton', 'expanceColumn']

  toggleExpanceColumn(event) {
    const title = event.currentTarget
    const content = title.nextElementSibling
    const state = title.dataset.footerValue

    const isCollapsed = state === 'collapsed'
    const toggleTo = isCollapsed ? 'expanded' : 'collapsed'

    const contentHeight = content.scrollHeight
    const transitionSpeed = (contentHeight * 1.25).toFixed(2)

    title.classList.toggle('expanded')

    content.style.transition = `max-height ${transitionSpeed}ms ease-out, opacity ${transitionSpeed}ms ease-out`
    content.style.maxHeight = isCollapsed ? `${contentHeight}px` : null

    title.dataset.footerValue = toggleTo
  }

  toggleExpanceLinks(event) {
    const idx = this.expanceButtonTargets.indexOf(event.currentTarget)
    const list = this.expancedListTargets[idx]

    event.currentTarget.classList.toggle('hidden')
    list.classList.toggle('hidden')

    const parent = list.parentElement
    parent.style.maxHeight = list.classList.contains('hidden')
      ? null
      : `${parent.scrollHeight}px`
  }
}
